document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-home-add-to-cart').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: this.dataset.variantId,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(() => {
        // Tell the theme something changed
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .catch(console.error);
    });
  });
});